<div class="img-container">
	<img [src]="img" style="width:100%">
	<label class="centered" [innerHTML]="title"></label>
</div>